// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/aircraft-interim-registration.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/aircraft-interim-registration/aircraft-interim-registration.js';

mount([g0]);
